const required = (key: string, value: string | undefined): string => {
  if (!value) throw new Error(`Missing env ${key}`);
  return value;
};

const backend = required("REACT_APP_BACKEND_URL", process.env.REACT_APP_BACKEND_URL).replace(/\/$/, "");

export const env = {
  backendUrl: backend,
  apiBase: `${backend}/api`,
  wsBase: `${backend.replace(/^http/, "ws")}/api/ws`,
  mapProvider: process.env.REACT_APP_MAP_PROVIDER || "osm",
  mapTileUrl: required("REACT_APP_MAP_TILE_URL", process.env.REACT_APP_MAP_TILE_URL),
  mapAttribution: process.env.REACT_APP_MAP_ATTRIBUTION || "",
  version: process.env.REACT_APP_VERSION || "dev",
  defaultCenter: { lat: 10.3157, lng: 123.8854 },
};
